import "$styles/index.css"
import Willamette from "willamette"
// TODO: import "htmx.org"

Willamette.init()
const lightBulb = document.querySelector("body > header a[href$='#light']")
if (localStorage.getItem("wa-color-mode") === "light") {
  document.documentElement.classList.remove("wa-dark")
  setBulbToMoon()
} else {
  document.documentElement.classList.add("wa-dark")
}

lightBulb.addEventListener("click", (event) => {
  event.preventDefault()
  if (event.currentTarget.href.endsWith("#light")) {
    document.documentElement.classList.remove("wa-dark")
    localStorage.setItem("wa-color-mode", "light")
    setBulbToMoon()
  } else {
    document.documentElement.classList.add("wa-dark")
    localStorage.removeItem("wa-color-mode")
    setMoonToBulb()
  }
})

function setBulbToMoon() {
  lightBulb.href = lightBulb.href.replace("light", "dark")
  lightBulb.querySelector("wa-icon").name = "moon"
}
function setMoonToBulb() {
  lightBulb.href = lightBulb.href.replace("dark", "light")
  lightBulb.querySelector("wa-icon").name = "lightbulb"
}

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"
